import * as config from 'config';
import session from 'lib/session';
import { createReducer } from 'redux/shelf';
import { get, post } from 'redux/shelf/api';

const useLegacyAdminOnboarding = config.adminApiLegacy.onboarding;

export const actions = {
  fetchStatus: get`/onboarding/status`(undefined, useLegacyAdminOnboarding),
  updateOnboarding: post`/onboarding/:id/generic/:roleID`(
    undefined,
    useLegacyAdminOnboarding
  ),
  validateOnboarding: post`/onboarding/:id/validate/:roleID`(
    undefined,
    useLegacyAdminOnboarding
  ),
  startOnboarding: post`/onboarding/:id/start/:roleID`(
    undefined,
    useLegacyAdminOnboarding
  ),
  onboardShopify: post`/oauth/plan/shopify/liquid/${session.getMerchant}`(
    undefined,
    useLegacyAdminOnboarding
  ),
};

export const reducer = createReducer([actions.fetchStatus]);
